"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const lodash_1 = __importDefault(require("lodash"));
const NODE_TYPE = 'FUNCTION';
class FunctionNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.asynchronousResolver = async (nodeMap, configFunctions, seedData) => {
            //Function id is in the form <name>::<version>
            const _a = await this.asynchronousResolveInputs(nodeMap), { conditionalEvaluationParameterSet } = _a, params = __rest(_a, ["conditionalEvaluationParameterSet"]);
            if (conditionalEvaluationParameterSet && conditionalEvaluationParameterSet.skipEvaluation) {
                conditionalEvaluationParameterSet.outputIfSkipped;
            }
            try {
                const [functionName, versionString] = this.config.functionId.split("::");
                const map = (lodash_1.default.find(configFunctions[functionName].versions, { versionNumber: +versionString })).aggregateMap;
                return await this.mapScenarios.FUNCTION_MAPPING.evaluate(map, Object.assign(Object.assign({}, this.accessorMap), { DATA: () => params }), configFunctions, seedData === null || seedData === void 0 ? void 0 : seedData.timestamp, seedData === null || seedData === void 0 ? void 0 : seedData.parentNodeId);
            }
            catch (e) {
                console.error("Function error: ", e.errorMessage);
                return null;
            }
        };
        this.synchronousResolver = (_nodeMap) => {
            throw new Error('Function is not allowed as a synchronously resolving node');
        };
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        var _a, _b;
        // grab the input schema from our schema loader
        const inputSchema = this.schemaLookup.getFunctionInput((_a = this.config) === null || _a === void 0 ? void 0 : _a.functionId) || {};
        const outputSchema = this.schemaLookup.getFunctionOutput((_b = this.config) === null || _b === void 0 ? void 0 : _b.functionId) || {};
        // grab the available event schemas
        const schemas = this.schemaLookup.getFunctions()
            .map((schema) => schema.schemaId).sort((a, b) => a.toLocaleLowerCase() > b.toLocaleLowerCase() ? 1 : -1);
        return Object.assign(Object.assign({}, Schema), { ConfigParams: {
                type: 'object',
                properties: {
                    functionId: {
                        description: 'Function',
                        type: 'string',
                        enum: schemas,
                    },
                },
            }, InputParams: Object.assign(Object.assign({}, inputSchema), { properties: Object.assign(Object.assign({}, inputSchema.properties), { conditionalEvaluationParameterSet: {
                        type: 'object',
                        description: 'Conditional Evaluation',
                        properties: {
                            skipEvaluation: {
                                type: 'boolean',
                                description: 'Skip Evaluation'
                            },
                            outputIfSkipped: Object.assign(Object.assign({}, outputSchema), { description: 'Output If Skipped' })
                        }
                    } }) }), OutputParams: outputSchema });
    }
}
exports.FunctionNode = FunctionNode;
FunctionNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Function',
    isIdempotent: false,
    primaryCategory: 'Conversion',
};
//# sourceMappingURL=Function.js.map